<template>
    <div>
        <div
            class="mt-8 items-center gap-6 sm:gap-10 md:gap-8 lg:flex lg:gap-10"
        >
            <div
                class="mb-4 aspect-[1/1] w-2/5 rounded-lg shadow-card sm:w-28 md:w-24 lg:mb-0 lg:w-32"
            >
                <template v-if="isStoryblokImage(item.image.src)">
                    <template v-if="item.link">
                        <a
                            :href="item.link.url"
                            :target="
                                item.link.target ? item.link.target : '_self'
                            "
                        >
                            <StoryblokImage
                                :src="item.image.src"
                                :alt="item.image.alt ? item.image.alt : ''"
                                sizes="130px md:112px"
                                :image-width="112"
                                :image-height="112"
                                :preload="false"
                                class="h-full w-full object-contain p-2"
                            />
                        </a>
                    </template>
                    <StoryblokImage
                        v-else
                        :src="item.image.src"
                        :alt="item.image.alt ? item.image.alt : ''"
                        sizes="130px md:112px"
                        :image-width="112"
                        :image-height="112"
                        :preload="false"
                        class="h-full w-full object-contain p-2"
                    />
                </template>
                <template v-else>
                    <template v-if="item.link">
                        <a
                            :href="item.link.url"
                            :target="
                                item.link.target ? item.link.target : '_self'
                            "
                        >
                            <img
                                :src="item.image.src"
                                :alt="item.image.alt ? item.image.alt : ''"
                                width="112"
                                height="112"
                                class="h-full w-full object-contain p-2"
                            />
                        </a>
                    </template>
                    <img
                        v-else
                        :src="item.image.src"
                        :alt="item.image.alt ? item.image.alt : ''"
                        width="112"
                        height="112"
                        class="h-full w-full object-contain p-2"
                    />
                </template>
            </div>

            <div class="flex-1">
                <h4>{{ item.title }}</h4>
                <WysiwygContent
                    v-if="item.content"
                    :content="item.content"
                    class="mt-2"
                />
                <div v-if="item.link" class="mt-2">
                    <a
                        :href="item.link.url"
                        :target="item.link.target ? item.link.target : '_self'"
                    >
                        {{ item.link.label }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { RelatedItem } from '~/types/miscellaneous';

defineProps<{
    item: RelatedItem;
}>();

const isStoryblokImage = (src: string) => {
    return src && src.includes('storyblok.com');
};
</script>
